import { makeStyles } from '@material-ui/core';
import { fontFamily } from '@src/art/theme/textStyles';
import CrownIcon from '@art/icons/crown.svg';
import { muteIcon } from './icons';

export const styles = makeStyles((theme) => ({
  containerStyles: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    marginBottom: '20px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '600px',
      marginBottom: '100px',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '875px',
      marginBottom: 'auto',
      marginTop: '30px',
    },
  },

  containerVolume: {
    margin: 'auto',
    width: '100%',
    height: '100%',
    position: 'absolute',
  },

  crownIcon: {
    position: 'absolute',
    zIndex: 10,
    top: 0,
    left: 0,
    width: '32px',
    height: '32px',
    backgroundColor: 'rgba(0,0,0, 0.45)',
    backgroundSize: '21px auto',
    backgroundImage: `url(${CrownIcon})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '4px 0px',
    [theme.breakpoints.up('sm')]: {
      width: '44px',
      height: '44px',
      backgroundSize: '28px auto',
    },
  },

  userAnswer: {
    width: '100%',
    padding: '6px 0',
    justifyContent: 'center',
    top: '97%',
    position: 'absolute',
    zIndex: 5,
    background: 'linear-gradient(77.61deg, #FDCC88 0%, #FCBC85 51.56%, #FC9E8C 100%)',
    borderRadius: '0px 0px 8px 8px',
    [theme.breakpoints.up('sm')]: {
      padding: '9px 0',
    },
  },

  userAnswerText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '14px',
    textAlign: 'center',
    color: '#1B2036',
    fontFamily: fontFamily,
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
      lineHeight: '19px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
      lineHeight: '17px',
    },
  },

  personContainer: {
    position: 'relative',
    display: 'flex',
    flexGrow: 0,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#C4C4C4',
    borderRadius: '10px',
    maxWidth: '215px',
    height: '55vw',
    width: '100%',
    boxShadow: 'none',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '270px',
      maxHeight: '360px',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '420px',
      maxHeight: '235px',
      width: '100%',
      height: '17vw',
      marginBottom: '30px',
    },
    '&:first-child': {
      marginRight: '30px',
    },
  },

  pairContainer: {
    transitionDelay: '2s',
    transitionDuration: '0s',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    display: 'block',
  },

  normalContainer: {
    position: 'relative',
    borderRadius: '4px',
    display: 'flex',
  },

  muteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '55px',
    height: '55px',
    position: 'absolute',
    right: '1px',
    bottom: '12px',
    zIndex: 5,
    backgroundSize: 'contain',
    backgroundImage: `url(${muteIcon})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.up('sm')]: {
      width: '110px',
      height: '110px',
      bottom: '22px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '55px',
      height: '55px',
      bottom: '12px',
    },
  },
}));
